<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="10">
        <v-card class="elevation-4">
          <v-card-title>
            Change Password
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="$router.push('/agent/dashboard')">Dashboard</v-btn>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-form v-model="valid" id="changepassword" >
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="password"
                      type="password"
                      name="password"
                      label="New Password"
                      v-validate="'required|min:6'"
                      :error-messages="errors.collect('password')"
                      data-vv-name="password"
                      ref="password"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="password_confirmation"
                      type="password"
                      name="password_confirmation"
                      label="Confirm Password"
                      v-validate="'required|confirmed:password'"
                      :error-messages="errors.collect('password_confirmation')"
                      data-vv-name="password_confirmation"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <div class="my-3">
                  <v-btn color="primary" @click="submit">Change Password</v-btn>
                </div>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
export default {
    props: {
    source: String
  },
  data: () => ({
    valid: true,
    password:'',
    password_confirmation:''

  }),

  computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    },

  },
  methods: {
    submit() {

      if (this.$validator.validateAll()) {
          let fd = new FormData(document.getElementById('changepassword'));
          this.$http.post('https://api.juzzap.com/api/agent/changepass',fd)
        .then(res=>{
          //this.$router.push('/dashboard');
          this.logout();
        })
        .catch(err=>{
          console.log(err.response);
        });
      }
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/agent/login");
      });
    }
  }
};
</script>
